// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tvm_payment_progress[data-v-b88fc7fc] {
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #eee;
}
.tvm_payment_progress .progress_bar[data-v-b88fc7fc] {
  height: 45px;
  object-fit: contain;
}
.tvm_payment_progress .left_value[data-v-b88fc7fc] {
  left: -7px;
  top: 35px;
}
.tvm_payment_progress .middle_value[data-v-b88fc7fc] {
  right: 80px;
  top: 42px;
}
.tvm_payment_progress .right_value[data-v-b88fc7fc] {
  right: -7px;
  top: 35px;
}
@media screen and (min-width: 1900px) {
.tvm_payment_progress .middle_value[data-v-b88fc7fc] {
    right: 100px;
    top: 46px;
}
.tvm_payment_progress .confirm_section .ft-13[data-v-b88fc7fc] {
    font-size: 14px !important;
}
}
.bb-est-con[data-v-b88fc7fc] {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  width: 100%;
  margin: 0 0 5px 0;
}
.bb-dis[data-v-b88fc7fc] {
  font-size: 12px;
}
.selected-condition[data-v-b88fc7fc] {
  font-weight: bold;
  background: #eee;
}
.bb__table__1[data-v-b88fc7fc] {
  width: 100%;
  border: 0;
  margin: 0 0 0px 0;
}
.bb__table__2[data-v-b88fc7fc] {
  width: 100%;
  border: 1px solid #dbdbdb;
  margin: 0 0 10px 0;
}
.confirm_section[data-v-b88fc7fc] {
  margin: 15px 0;
  word-break: break-word;
}
.bb__table__1 th[data-v-b88fc7fc],
.bb__table__1 td[data-v-b88fc7fc],
.bb__table__2 th[data-v-b88fc7fc],
.bb__table__2 td[data-v-b88fc7fc] {
  font-size: 12px;
  padding: 5px;
}
.bb__table__1 th[data-v-b88fc7fc],
.bb__table__2 th[data-v-b88fc7fc] {
  width: 44%;
}
.bb__table__1 td[data-v-b88fc7fc]:nth-of-type(1),
.bb__table__2 td[data-v-b88fc7fc]:nth-of-type(1) {
  width: 6%;
}
.bb__table__1 td[data-v-b88fc7fc]:nth-of-type(2),
.bb__table__2 td[data-v-b88fc7fc]:nth-of-type(2) {
  width: 50%;
}
.cursor-pointer[data-v-b88fc7fc] {
  cursor: pointer;
}
.trade_details_table[data-v-b88fc7fc] {
  border: 1px solid #eee !important;
}
.trade_details_table tr td[data-v-b88fc7fc] {
  border: 0;
  padding: 8px 20px;
  font-size: 14px;
}
.trade_details_table tr td[data-v-b88fc7fc]:first-child {
  border-right: 1px solid #eee;
  max-width: 100px;
}
.view_details[data-v-b88fc7fc] {
  position: relative;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/TvmSellUsYourCar/TvmBbTradeValue.vue","webpack://./TvmBbTradeValue.vue"],"names":[],"mappings":"AACA;EACE,sBAAA;EACA,kBAAA;EACA,sBAAA;ACAF;ADHA;EAMI,YAAA;EACA,mBAAA;ACAJ;ADPA;EAWI,UAAA;EACA,SAAA;ACDJ;ADXA;EAgBI,WAAA;EACA,SAAA;ACFJ;ADfA;EAqBI,WAAA;EACA,SAAA;ACHJ;ADME;AAAA;IAEI,YAAA;IACA,SAAA;ACJJ;ADCA;IAOI,0BAAA;ACLJ;AACF;ADSA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;ACPF;ADUA;EACE,eAAA;ACRF;ADWA;EACE,iBAAA;EACA,gBAAA;ACTF;ADYA;EACE,WAAA;EACA,SAAA;EACA,iBAAA;ACVF;ADaA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;ACXF;ADcA;EACE,cAAA;EACA,sBAAA;ACZF;ADeA;;;;EAIE,eAAA;EACA,YAAA;ACbF;ADgBA;;EAEE,UAAA;ACdF;ADiBA;;EAEE,SAAA;ACfF;ADkBA;;EAEE,UAAA;AChBF;ADmBA;EACE,eAAA;ACjBF;ADoBA;EACE,iCAAA;AClBF;ADqBA;EACE,SAAA;EACA,iBAAA;EACA,eAAA;ACnBF;ADsBA;EACE,4BAAA;EACA,gBAAA;ACpBF;ADuBA;EACE,kBAAA;EACA,qBAAA;ACrBF","sourcesContent":["\n.tvm_payment_progress {\n  background-color: #fff;\n  border-radius: 5px;\n  border: 1px solid #eee;\n\n  .progress_bar {\n    height: 45px;\n    object-fit: contain;\n  }\n\n  .left_value {\n    left: -7px;\n    top: 35px;\n  }\n\n  .middle_value {\n    right: 80px;\n    top: 42px;\n  }\n\n  .right_value {\n    right: -7px;\n    top: 35px;\n  }\n\n  @media screen and (min-width: 1900px) {\n    .middle_value {\n      right: 100px;\n      top: 46px;\n    }\n\n    .confirm_section .ft-13 {\n      font-size: 14px !important;\n    }\n  }\n}\n\n.bb-est-con {\n  font-size: 14px;\n  font-weight: bold;\n  display: flex;\n  width: 100%;\n  margin: 0 0 5px 0;\n}\n\n.bb-dis {\n  font-size: 12px;\n}\n\n.selected-condition {\n  font-weight: bold;\n  background: #eee;\n}\n\n.bb__table__1 {\n  width: 100%;\n  border: 0;\n  margin: 0 0 0px 0;\n}\n\n.bb__table__2 {\n  width: 100%;\n  border: 1px solid #dbdbdb;\n  margin: 0 0 10px 0;\n}\n\n.confirm_section {\n  margin: 15px 0;\n  word-break: break-word;\n}\n\n.bb__table__1 th,\n.bb__table__1 td,\n.bb__table__2 th,\n.bb__table__2 td {\n  font-size: 12px;\n  padding: 5px;\n}\n\n.bb__table__1 th,\n.bb__table__2 th {\n  width: 44%;\n}\n\n.bb__table__1 td:nth-of-type(1),\n.bb__table__2 td:nth-of-type(1) {\n  width: 6%;\n}\n\n.bb__table__1 td:nth-of-type(2),\n.bb__table__2 td:nth-of-type(2) {\n  width: 50%;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.trade_details_table {\n  border: 1px solid #eee !important;\n}\n\n.trade_details_table tr td {\n  border: 0;\n  padding: 8px 20px;\n  font-size: 14px;\n}\n\n.trade_details_table tr td:first-child {\n  border-right: 1px solid #eee;\n  max-width: 100px;\n}\n\n.view_details {\n  position: relative;\n  display: inline-block;\n}\n",".tvm_payment_progress {\n  background-color: #fff;\n  border-radius: 5px;\n  border: 1px solid #eee;\n}\n.tvm_payment_progress .progress_bar {\n  height: 45px;\n  object-fit: contain;\n}\n.tvm_payment_progress .left_value {\n  left: -7px;\n  top: 35px;\n}\n.tvm_payment_progress .middle_value {\n  right: 80px;\n  top: 42px;\n}\n.tvm_payment_progress .right_value {\n  right: -7px;\n  top: 35px;\n}\n@media screen and (min-width: 1900px) {\n  .tvm_payment_progress .middle_value {\n    right: 100px;\n    top: 46px;\n  }\n  .tvm_payment_progress .confirm_section .ft-13 {\n    font-size: 14px !important;\n  }\n}\n.bb-est-con {\n  font-size: 14px;\n  font-weight: bold;\n  display: flex;\n  width: 100%;\n  margin: 0 0 5px 0;\n}\n.bb-dis {\n  font-size: 12px;\n}\n.selected-condition {\n  font-weight: bold;\n  background: #eee;\n}\n.bb__table__1 {\n  width: 100%;\n  border: 0;\n  margin: 0 0 0px 0;\n}\n.bb__table__2 {\n  width: 100%;\n  border: 1px solid #dbdbdb;\n  margin: 0 0 10px 0;\n}\n.confirm_section {\n  margin: 15px 0;\n  word-break: break-word;\n}\n.bb__table__1 th,\n.bb__table__1 td,\n.bb__table__2 th,\n.bb__table__2 td {\n  font-size: 12px;\n  padding: 5px;\n}\n.bb__table__1 th,\n.bb__table__2 th {\n  width: 44%;\n}\n.bb__table__1 td:nth-of-type(1),\n.bb__table__2 td:nth-of-type(1) {\n  width: 6%;\n}\n.bb__table__1 td:nth-of-type(2),\n.bb__table__2 td:nth-of-type(2) {\n  width: 50%;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.trade_details_table {\n  border: 1px solid #eee !important;\n}\n.trade_details_table tr td {\n  border: 0;\n  padding: 8px 20px;\n  font-size: 14px;\n}\n.trade_details_table tr td:first-child {\n  border-right: 1px solid #eee;\n  max-width: 100px;\n}\n.view_details {\n  position: relative;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
